/* eslint-disable */
import React, { useState, useEffect, createContext, Fragment } from 'react';
import {
  Button, Box, Checkbox, Grid, CardHeader, CardContent, Card, Divider,
  Typography, Container
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import services from '../Services';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';
import { Switch, Select } from '@material-ui/core';
import { useNavigate, useParams } from 'react-router-dom';
import tokenService from '../../../../helpers/TokenDecoder';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import Chip from '@material-ui/core/Chip';
import LabelIcon from '@material-ui/icons/Label';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));
export default function PermissionListing() {
  const classes = useStyles();
  const [title, setTitle] = useState("")
  const [permission, setPermission] = useState([]);
  const [screen, setScreen] = useState([]);
  const [ModifiedLeftList, setModifiedLeftList] = useState([]);
  const [ModifiedRightList, setModifiedRightList] = useState([]);
  const [unmodifiedPermission, setUnmodifiedPermission] = useState([]);
  const [updatingRoleID, setupdatingRoleID] = useState();
  const [buttonName, setButtonName] = useState("Save");
  const [clearPermission, setClearPermission] = useState({
    unmodifiedList: unmodifiedPermission,
    modifiedList: permission
  });

  const [isSaveDisable, setIsSaveDisable] = useState(false);
  const [isDataLoad, setDataLoadTrue] = useState(false);
  const [updatingRoleLevelID, setupUpdatingRoleLevelID] = useState();
  const params = useParams();

  let decryptedRole = 0;
  let decryptedroleLevelID = 0;
  let decryptedroleLevelName = "";
  useEffect(() => {

    decryptedRole = AESDecryptionParam(params.roleID.toString());
    decryptedroleLevelID = AESDecryptionParam(params.roleLevelID.toString());
    decryptedroleLevelName = AESDecryptionParam(params.roleName.toString());
    if (decryptedRole != 0) {
      setTitle(decryptedroleLevelName);
      setupdatingRoleID(decryptedRole)
      setupUpdatingRoleLevelID(decryptedroleLevelID)

    }

  }, []);

  useEffect(() => {

    if (tokenService.getRoleLevelFromToken() != 1 && updatingRoleID == tokenService.getRoleIDFromToken()) {
      setIsSaveDisable(true);
    }
    else {
      setIsSaveDisable(false);
    }


    getAllPermission()

  }, [updatingRoleID]);


  useEffect(() => {

    if (updatingRoleLevelID < tokenService.getRoleLevelFromToken()) {
      setIsSaveDisable(true);
    }
    else {
      setIsSaveDisable(false);
    }

  }, [updatingRoleLevelID]);

  const navigate = useNavigate();


  function handlePermissionChange(permissionID, screenID) {
    var modifiedPermission = [...permission];
    modifiedPermission.forEach(p => {
      if (p.permissionID == permissionID) {
        p.isAssigned = !p.isAssigned
      }
    });
    setPermission(modifiedPermission);

    var count = 0;
    var trueCount = 0;
    var updateCount = [...permission];
    updateCount.forEach(p => {
      if (p.screenID == screenID) {
        count++;
        if (p.isAssigned == true) {
          trueCount++;
        }
      }
    });
    setPermission(updateCount);

    var updateScreen = [...screen];
    updateScreen.forEach(s => {
      if (s.screenID == screenID) {
        if (trueCount == count) {
          s.isOpen = true;
        } else {
          s.isOpen = false;
        }
      }
    });
    setScreen(updateScreen);
  }

  function handleScreenChange(screenID) {
    var updateScreen = [...screen];
    updateScreen.forEach(s => {
      if (s.screenID == screenID) {
        s.isOpen = !s.isOpen;
      }
    });
    setScreen(updateScreen);

    var checkAllScreen = [...screen];
    checkAllScreen.forEach(s => {
      if (s.screenID == screenID) {
        if (s.isOpen) {
          var updateCount = [...permission];
          updateCount.forEach(p => {
            if (p.screenID == screenID) {
              p.isAssigned = true;
            }
          });
          setPermission(updateCount);
        } else {
          var permissionList = [...permission];
          permissionList.forEach(p => {
            if (p.screenID == screenID) {
              p.isAssigned = false;
            }
          })
          setPermission(permissionList);
        }
      }
    });
  }

  function handleClickCheckbox(e) {
    e.stopPropagation();
  }

  async function getAllPermission() {

    var permissionData = await services.getPermissionNameAndScreenNameForCheckbox(tokenService.getRoleIDFromToken(), updatingRoleID);
    sortArrayList(permissionData.data.screens);
    setScreen(permissionData.data.screens);
    setPermission(permissionData.data.permissions);
    setUnmodifiedPermission(permissionData.data.unmodifiedPermissions);

    if (permissionData.data.screens.length > 0) {
      setDataLoadTrue(true)
    }

  }

  function sortArrayList(data) {

    if (data.length <= 0) {
      return;
    }

    const groupByReferenceNumber = data.reduce((acc, obj) => {
      const parentMenuName = obj.parentMenuName;
      if (!acc[parentMenuName]) {
        acc[parentMenuName] = [];
      }
      acc[parentMenuName].push(obj);
      return acc;
    }, {});

    const sortedObjectList = Object.entries(groupByReferenceNumber).map(([key, value]) => ({
      screenName: key,
      valueList: value,
      parentMenuID: value[0].parentMenuID,
      isParentMenuOpen: (!value.some(e => e.isOpen === false))
    }));

    var arr = sortedObjectList;
    arr.sort(function (a, b) {
      return a.valueList.parentMenuName - b.valueList.parentMenuName;
    });

    let leftArray = [];
    let tempRightArray = [];

    for (let index = 0; index < arr.length; index++) {

      let tempObject = arr[index]

      if (index % 2) {
        tempObject['side'] = "left"
        leftArray.push(tempObject)
      } else {
        tempObject['side'] = "right"
        tempRightArray.push(arr[index])
      }

    }

    var rightArray = tempRightArray.reverse();
    setModifiedLeftList(leftArray)
    setModifiedRightList(rightArray)
  }

  function handleAllSelectByParentMenuID(menuID) {
    var updateScreen = [...screen];

    const selectedScreenCount = updateScreen.reduce((counter, obj) => {
      if (obj.parentMenuID === menuID) counter += 1
      return counter;
    }, 0);

    const selectedOpenedScreenCount = updateScreen.reduce((counter, obj) => {
      if (obj.parentMenuID === menuID && obj.isOpen === true) counter += 1
      return counter;
    }, 0);

    updateScreen.forEach(s => {
      if (s.parentMenuID == menuID) {
        if (selectedScreenCount === selectedOpenedScreenCount) {
          s.isOpen = false;
          s.isParentMenuOpen = false
        } else {
          s.isOpen = true;
          s.isParentMenuOpen = true
        }
      }
    });
    setScreen(updateScreen);
    sortArrayList(updateScreen)
    var checkAllScreen = [...screen];
    checkAllScreen.forEach(s => {
      if (s.parentMenuID == menuID) {
        if (s.isOpen) {
          var updateCount = [...permission];
          updateCount.forEach(p => {
            if (p.screenID == s.screenID) {
              p.isAssigned = true;
            }
          });
          setPermission(updateCount);
        } else {
          var permissionList = [...permission];
          permissionList.forEach(p => {
            if (p.screenID == s.screenID) {
              p.isAssigned = false;
            }
          })
          setPermission(permissionList);
        }
      }
    });
  }

  function handleClickCheckboxByParentMenuID(e) {
    e.stopPropagation();
  }

  async function handleSave(e) {

    e.preventDefault();
    setIsSaveDisable(true)

    const response = await services.saveRolePermission(unmodifiedPermission, permission, updatingRoleID)
    toast.success(response.message);
    afterSuccessfulyChanged(response.statusCode);
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      clearState()
      setTimeout(() => {
        navigate('/dashboard/userRole/');
      }, 3000);
    }
  }

  function clearState() {
    setClearPermission({
      ...clearPermission,
      unmodifiedList: null,
      modifiedList: null,
      roleID: null
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          {/* <PageHeader
            onClick={handleClick}
          /> */}
        </Grid>
      </Grid>
    )
  }

  return (
    <Page title="UserRole Permission |  FAPS">
      <Container>
        <CommonPageHeader
          path={"/dashboard/userRole/"}
          btname="Back"
          pageName="User Role Permissions"
        />
        <Box mt={0}>
          <Card>
            <CardHeader
              title={title}
            />

            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <CardContent>
              <form onSubmit={(e) => handleSave(e)}>
                <div className="card-body">
                  <div className="table-responsive row-top-gap">

                    <Grid container spacing={1}>
                      <Grid item md={6} xs={12}>
                        <Grid container spacing={1}>
                          {
                            ModifiedLeftList.map((s, index) => (
                              <Grid item md={12} xs={12}>
                                <Accordion>
                                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading} >
                                      <Checkbox
                                        color="secondary"
                                        onChange={() => handleAllSelectByParentMenuID(s.parentMenuID)}
                                        checked={s.isParentMenuOpen}
                                        onClick={e => handleClickCheckboxByParentMenuID(e)}
                                      />
                                      <label>{s.screenName === undefined || s.screenName === "null" || s.screenName === isNaN ? "COMMON" : s.screenName}</label>
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Grid item md={12} xs={12}>
                                      {s.valueList.map(s => {
                                        return (
                                          <Accordion>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                              <Typography className={classes.heading} >
                                                <Checkbox
                                                  color="secondary"
                                                  onChange={() => handleScreenChange(s.screenID)}
                                                  checked={s.isOpen}
                                                  onClick={e => handleClickCheckbox(e)}
                                                />
                                                <label>{s.screenName === undefined || s.screenName === "null" || s.screenName === isNaN ? "" : s.screenName}</label>
                                              </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                              <Typography>
                                                {permission.map(p => {
                                                  if (p.screenID == s.screenID) {
                                                    return (
                                                      <Fragment>
                                                        <ListItem button className={classes.nested}>
                                                          <ListItemIcon>
                                                            <LabelIcon />
                                                          </ListItemIcon>
                                                          <ListItemText primary={p.permissionName} />
                                                          <Switch
                                                            color="error"
                                                            checked={p.isAssigned}
                                                            label={p.permissionName}
                                                            onChange={() => handlePermissionChange(p.permissionID, p.screenID)}
                                                          />

                                                        </ListItem>
                                                      </Fragment>
                                                    );
                                                  }
                                                })}
                                              </Typography>
                                            </AccordionDetails>
                                          </Accordion>
                                        );
                                      })}
                                    </Grid>
                                  </AccordionDetails>
                                </Accordion>
                              </Grid>
                            ))
                          }
                        </Grid>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Grid container spacing={1}>
                          {
                            ModifiedRightList.map((s, index) => (
                              <Grid item md={12} xs={12}>
                                <Accordion>
                                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading} >
                                      <Checkbox
                                        color="secondary"
                                        onChange={() => handleAllSelectByParentMenuID(s.parentMenuID)}
                                        checked={s.isParentMenuOpen}
                                        onClick={e => handleClickCheckboxByParentMenuID(e)}
                                      />
                                      <label>{s.screenName === undefined || s.screenName === "null" || s.screenName === isNaN ? "COMMON" : s.screenName}</label>
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Grid item md={12} xs={12}>
                                      {
                                        s.valueList.map(s => {
                                          return (
                                            <Accordion>
                                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Typography className={classes.heading} >
                                                  <Checkbox
                                                    color="secondary"
                                                    onChange={() => handleScreenChange(s.screenID)}
                                                    checked={s.isOpen}
                                                    onClick={e => handleClickCheckbox(e)}
                                                  />
                                                  <label>{s.screenName === undefined || s.screenName === "null" || s.screenName === isNaN ? "" : s.screenName}</label>
                                                </Typography>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Typography>
                                                  {permission.map(p => {
                                                    if (p.screenID == s.screenID) {
                                                      return (
                                                        <Fragment>
                                                          <ListItem button className={classes.nested}>
                                                            <ListItemIcon>
                                                              <LabelIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary={p.permissionName} />
                                                            <Switch
                                                              color="error"
                                                              checked={p.isAssigned}
                                                              label={p.permissionName}
                                                              onChange={() => handlePermissionChange(p.permissionID, p.screenID)}
                                                            />
                                                          </ListItem>
                                                        </Fragment>
                                                      );
                                                    }
                                                  })}
                                                </Typography>
                                              </AccordionDetails>
                                            </Accordion>
                                          );
                                        })
                                      }
                                    </Grid>
                                  </AccordionDetails>
                                </Accordion>
                              </Grid>
                            ))
                          }
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </div>
                <Box display="flex" justifyContent="flex-end" p={2}>
                  {isDataLoad ? (
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      disabled={isSaveDisable}
                    >
                      {buttonName}
                    </Button>
                  ) : null}
                </Box>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

